import BillingInfoIcon from "public/cyber-security/edrmdrxdr/stash_billing-info.svg";
import SupportIcon from "public/cyber-security/edrmdrxdr/material-symbols_support.svg";
import RefreshIcon from "public/cyber-security/edrmdrxdr/charm_refresh.svg";
import ComplianceIcon from "public/cyber-security/edrmdrxdr/grommet-icons_compliance.svg";
import CubeImg from "public/cyber-security/edrmdrxdr/bxs_cube.svg";
import AnalyticsIcon from "public/cyber-security/edrmdrxdr/mdi_google-analytics.svg";

export const WHY_ONEMIND_CONSTANTS = {
  TITLE: " Why Security Teams Trust OneMind for Secure Access ",
  ITEMS: [
    {
      image: AnalyticsIcon,
      title: "Enforce Zero Trust Security",
      content:
        "Only authenticated users gain access — ensuring strong, policy-based protection at every entry point. ",
    },
    {
      image: CubeImg,
      title: "Secure Remote & Hybrid Workforces ",
      content:
        "Protect users across locations with encrypted, identity-driven access to business-critical applications.",
    },
    {
      image: ComplianceIcon,
      title: "Prevent Unauthorized Access ",
      content:
        " ZTNA continuously verifies identity and behavior before allowing any connection.",
    },
    {
      image: RefreshIcon,
      title: "Optimize Cloud & Remote Connectivity ",
      content:
        "SASE architecture integrates with SD-WAN to boost performance and ensure secure access at scale.",
    },

    {
      image: SupportIcon,
      title: "Detect & Block Cyber Threats in Real-Time ",
      content:
        "AI-powered VPN and firewall defenses stop malware and phishing before they cause damage. |",
    },
    {
      image: BillingInfoIcon,
      title: "Eliminate Attack Surfaces ",
      content:
        "Limit access to specific apps — not entire networks — to reduce risk without slowing down users. ",
    },
  ],
};
